import { defineNuxtPlugin } from "nuxt/app";

export default defineNuxtPlugin(() => {
  return {};
});
